(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-details')) {
    customElements.define('bundle-details', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        const dialog = this.querySelector('dialog');
        const opener = this.querySelector('[data-bdi-open]');
        const slides = [...this.querySelectorAll('.bdi-slide')];
        const dots = [...this.querySelectorAll('[data-bdi-index]')];
        let index = 0;

        const show = (next) => {
          index = Math.max(0, Math.min(slides.length - 1, next));

          slides.forEach((slide, i) => {
            slide.hidden = i !== index;
          });

          dots.forEach((dot, i) => {
            dot.setAttribute('aria-pressed', String(i === index));
          });

          this.querySelector('[data-bdi-count]').textContent =
            `Prodotto ${index + 1} di ${slides.length}`;

          this.querySelector('[data-bdi-prev]').disabled = index === 0;
          this.querySelector('[data-bdi-next]').disabled =
            index === slides.length - 1;

          this.querySelector('.bdi-body').scrollTop = 0;
        };

        const close = () => dialog.close();

        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;

          if (button === opener) {
            show(0);
            dialog.showModal();
            document.documentElement.classList.add('dialog-open');
          }

          if (button.hasAttribute('data-bdi-close')) close();
          if (button.hasAttribute('data-bdi-prev')) show(index - 1);
          if (button.hasAttribute('data-bdi-next')) show(index + 1);

          if (button.hasAttribute('data-bdi-index')) {
            show(Number(button.dataset.bdiIndex));
          }

          if (button.hasAttribute('data-bdi-select')) {
            const radio = document.getElementById(this.dataset.radioId);

            if (radio && radio.dataset.available !== 'false') {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
              close();
            }
          }
        });

        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;

          const rect = dialog.getBoundingClientRect();

          if (
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom
          ) close();
        });

        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            show(index + 1);
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            show(index - 1);
          }
        });

        dialog.addEventListener('close', () => {
          if (!document.querySelector('dialog[open]')) {
            document.documentElement.classList.remove('dialog-open');
          }

          opener.focus({ preventScroll: true });
        });

        show(0);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
